module.exports = __webpack_public_path__ + "7c946ef6ad278c8ecd54e0804b016b13.png";